<div class="container">
  <ya-map
    [state]="mapState"
    [options]="mapOptions"
    (sizechange)="sizeChange($event)"
    (actionend)="actionEnd($event)"
    (ready)="ready($event)"
  >
    <ya-clusterer [options]="clustererOptions">
      <ya-placemark
        *ngFor="let placemark of placemarks"
        [geometry]="[placemark.geometry.latitude, placemark.geometry.longitude]"
        [properties]="placemark.properties"
        [options]="placemark.options"
      ></ya-placemark>
    </ya-clusterer>
  </ya-map>
</div>
